import request from '@/utils/request'

export const getCustomers = () =>
  request({
    url: `/customer/all`,
    method: 'get'
  })
